import { IVindiFinancesData } from '~/models/Boss';

export const getPaymentType = (paymentMethod: string) => {
  const payment = {
    debit_card: 'Cartão de débito',
    billet: 'Boleto',
    cash: 'Dinheiro',
    default: 'Não identificado',
    credit_card: 'Cartão de crédito',
    transfer: 'Transferência',
    others: 'Outros',
  };

  if (!payment[paymentMethod as keyof typeof payment]) {
    return 'outros';
  }

  return payment[paymentMethod as keyof typeof payment];
};

export const getPaymentStatus = (paymentStatus: string) => {
  const status = {
    pending: 'pendente',
    overdue: 'atrasado',
    paid: 'pago',
    canceled: 'cancelado',
  };

  if (!status[paymentStatus as keyof typeof status]) return 'outros';

  return status[paymentStatus as keyof typeof status];
};

export const handleGetAgeGroup = (age: number) => {
  if (age <= 19 && age !== null) {
    return '-20';
  }
  if (age >= 20 && age <= 30) {
    return '20-30';
  }
  if (age >= 31 && age <= 40) {
    return '31-40';
  }
  if (age >= 41 && age <= 50) {
    return '41-50';
  }
  if (age >= 51 && age <= 60) {
    return '51-60';
  }
  if (age >= 61) {
    return '+60';
  }
  return 'N/I';
};

export const filterVindiBillsData = (bills: IVindiFinancesData['bills']) => {
  const pendingBills = bills.filter((bill) => bill.status === 'pending');

  const pendingBillsAmount = pendingBills.reduce(
    (acc, bill) => acc + parseFloat(bill.amount),
    0,
  );

  const paidBills = bills.filter((bill) => bill.status === 'paid');

  const paidBillsAmount = paidBills.reduce(
    (acc, bill) => acc + parseFloat(bill.amount),
    0,
  );

  const canceledBills = bills.filter((bill) => bill.status === 'canceled');

  const countAndSumSubscriptionsByStatus = [
    {
      count: String(canceledBills.length),
      payment_status: 'canceled',
      payment_total: '0',
    },
    {
      count: String(paidBills.length),
      payment_status: 'paid',
      payment_total: String(paidBillsAmount),
    },
    {
      count: String(pendingBills.length),
      payment_status: 'pending',
      payment_total: String(pendingBillsAmount),
    },
  ];

  const countSubscriptionsByStatusFiltered = [
    {
      count: canceledBills.length,
      payment_status: 'Cancelado',
    },
    {
      count: paidBills.length,
      payment_status: 'Pago',
    },
    {
      count: pendingBills.length,
      payment_status: 'Pendente',
    },
  ];

  return {
    countAndSumSubscriptionsByStatus,
    countSubscriptionsByStatusFiltered,
  };
};
